import { Component } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { environment } from 'src/environments/environment';
import {
  AnalyticsLoggerService,
  GENERAL_EVENTS,
} from 'src/app/services/analytics-logger.service';
import { EnvironmentService } from 'src/app/services/environment.service';

@Component({
  selector: 'cover-faq',
  standalone: true,
  imports: [MatExpansionModule, MatIconModule],
  templateUrl: './cover-faq.component.html',
  styleUrl: './cover-faq.component.scss',
})
export class CoverFaqComponent {
  environment = environment;

  loggedEvents: string[] = [];

  public GENERAL_EVENTS = GENERAL_EVENTS;

  constructor(
    private logger: AnalyticsLoggerService,
    public env: EnvironmentService
  ) {}

  logEventOnce(event: string) {
    if (!this.loggedEvents.includes(event)) {
      this.logger.logEvent(event);
      this.loggedEvents.push(event);
    }
  }
}
